<template>
    <v-card class="elevation-0" rounded="0">
        <v-card-title>
            <v-icon start color="primary">mdi-comment-text</v-icon>
            {{ $t('special_remark_rm') }}
        </v-card-title>
        <v-card-text>
            <v-form ref="form" :disabled="disabled">
                <v-textarea v-model="specialRemarkRM" :placeholder="$t('type_here')" rows="1" />
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class SpecialRemarkRM extends Vue {
        @Prop() disabled
        @VModel() specialRemarkRM
    }

    export default SpecialRemarkRM
</script>
